export default "__VITE_ASSET__t3WC25uZ__"